import axios from "axios";
import * as types from "../ActionType";
import { notifyError } from "../../components/general/Notification";
const END_POINT = process.env.REACT_APP_BASE_URL_AUTH;

const get = (arr, type) => {
    return ({
        type: type,
        payload: arr
    })
}

export const loadNotifications = (offset, limit, setHasMore) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");

        const queryParams = [];
        if (limit !== null) queryParams.push(`per_page=${limit}`);
        const finalQuery = queryParams.join('&');
        const apiUrl = `${END_POINT}/api/notifications?${finalQuery}`;
       console.log(apiUrl);

        axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                console.log(res.data.data);
                dispatch(get(res.data.data,types.GET_NOTIFICATIONS));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}